// import package
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom'

// import component
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import ProofForm from './ProofForm';
import AddressProofConfirm from './AddressProofConfirm';

// import lib
import isEmpty from '../../lib/isEmpty';

const IDProof = () => {
    const { t, i18n } = useTranslation();

    // state
    const [ show, setShow ] = useState(false);

    // redux-state
    const { idProof } = useSelector(state => state.userKyc);
    const { firstName, lastName, address, city, country, blockNo, postalCode } = useSelector(state => state.account);

    const checkProfileUpdate = () => {
        return !(isEmpty(firstName) || isEmpty(lastName) || isEmpty(address) || isEmpty(city) || isEmpty(country) || isEmpty(blockNo) || isEmpty(postalCode))    
    }

    const showModal = () => {
        setShow(true);
    }

    return (
        <>
            <AddressProofConfirm 
                show={show}
                onHide={ () => setShow(false)}
            />

            <div className="row align-items-center">
                <div className="col-lg-12">
                    <h3 className="dash_title mb-3">{ t("IDENTITY_DOCUMENT") }</h3>
                </div>
            </div>
            <div className="dashboard_box">
                <div className="kycIdentityDocument">
                    <GridContainer>
                        {
                            checkProfileUpdate() && idProof && ['new', 'rejected'].includes(idProof.status) && <>
                                <p>{t("IDENTITY_DOCUMENT_TITLE1")}</p>
                                <GridItem xs={12} sm={12} md={7} lg={7}>
                                    <div className="twoFAForm">
                                        <ProofForm showModal={showModal} />
                                    </div>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={5} lg={5}>
                                    <div className="settingsNote">
                                        <h6>{t("NOTES")}</h6>
                                        <ul>
                                            <li>{t("IDENTITY_DOCUMENT_DESCRIPTION1")}</li>
                                            <li>{t("IDENTITY_DOCUMENT_DESCRIPTION2")}</li>
                                            <li>{t("IDENTITY_DOCUMENT_DESCRIPTION3")}{/*  <a href="#">{t("HERE")}</a> */}</li>
                                        </ul>
                                    </div>
                                </GridItem>
                            </>
                        }

                        {
                            idProof && !['new', 'rejected'].includes(idProof.status) && <GridItem xs={12} sm={12} md={12} lg={12}>
                                <div className="verifiedDocument">
                                    <h3>{t("IDENTITY_DOCUMENT_VERIFIED")}</h3>
                                    <p>{t("IDENTITY_DOCUMENT_DESCRIPTION4")} <Link to="/support-ticket">{t("SUPPORT_TEAM")}</Link></p>
                                </div>
                            </GridItem>
                        }

                        {
                            !checkProfileUpdate() && <GridItem xs={12} sm={12} md={12} lg={12}>
                                <div className="verifiedDocument">
                                    <h3 style={{'color' : 'red' }}>{t("PROFILE_MANDATORY_MSG")}</h3>
                                </div>
                            </GridItem>
                        }

                    </GridContainer>
                </div>
            </div>
        </>
    )
}

export default IDProof;